import { Skeleton } from "@/components/ui/skeleton"
import { cn } from "@/utilities"

export const ProductCardSkeleton = ({ className }: { className?: string }) => {
  return (
    <div className={cn("group block h-100 w-75", className)}>
      <article className='flex h-full flex-col rounded-lg border border-gray-200 bg-white'>
        <Skeleton className='aspect-4/3 max-h-50 w-full rounded-t-lg' />

        <div className='z-50 flex flex-col gap-2 border-gray-200 border-t bg-white p-4'>
          <div className='space-y-1'>
            <Skeleton className='h-4 w-full' />
            <Skeleton className='h-4 w-3/4' />
          </div>

          <div className='mt-auto space-y-1'>
            <Skeleton className='h-5 w-20 rounded' />

            <Skeleton className='h-6 w-32' />
          </div>
        </div>
      </article>
    </div>
  )
}
